<template>
  <n-config-provider
    :theme-overrides="themeOverrides"
    :date-locale="naiveDateLocale"
    :locale="naiveLocale"
  >
    <n-dialog-provider>
      <n-message-provider>
        <router-view />
      </n-message-provider>
    </n-dialog-provider>
  </n-config-provider>
</template>

<script setup lang="ts">
import './assets/_variables.css';

import type { NDateLocale, NLocale } from 'naive-ui';
import { dateEnUS, dateJaJP, dateZhTW, enUS, jaJP, zhTW } from 'naive-ui';
import { computed, onBeforeMount } from 'vue';

import i18n, { loadLocaleMessages } from './i18n';
import themeOverrides from './theme-overrides';

const naiveLocale = computed<NLocale>(() => {
  const locale = i18n.global.locale.value;
  const localeMap: Record<string, NLocale> = {
    zh: zhTW,
    ja: jaJP,
    en: enUS,
  };
  return localeMap[locale] || enUS;
});

const naiveDateLocale = computed<NDateLocale>(() => {
  const locale = i18n.global.locale.value;
  const dateLocaleMap: Record<string, NDateLocale> = {
    zh: dateZhTW,
    ja: dateJaJP,
    en: dateEnUS,
  };
  return dateLocaleMap[locale] || dateEnUS;
});

onBeforeMount(async () => {
  const userLocale = localStorage.getItem('user-locale');
  if (userLocale && i18n.global.locale.value !== userLocale) {
    await loadLocaleMessages(userLocale as 'zh' | 'en' | 'ja');
  }
});
</script>

<style>
/* dataTable empty state */
.empty-card {
  display: grid;
  place-items: center;
  height: 120px;
}

.disable-content {
  font-size: calc(var(--dd3-text-heading-sm-font-size) * 1px);
  color: var(--dd3-color-text-disabled);
}

.modal-header {
  font-size: calc(var(--dd3-text-heading-md-font-size) * 1px);
  font-weight: var(--dd3-text-heading-md-font-weight);
}
.cursor-move {
  cursor: move;
}

.app-container {
  height: 100%;
  padding: 24px;
}

/* 拖移列表 */
.center,
.flex-center {
  display: flex;
  align-items: center;
  justify-content: center;
}
.handle {
  text-align: center;
  cursor: move;
}

@media (max-width: 489px) {
  .app-container {
    padding: 24px 16px;
  }
}

.v-enter-active,
.v-leave-active {
  transition: opacity 0.2s ease-in-out;
}

.v-enter-from,
.v-leave-to {
  opacity: 0;
}

.slide-down-enter-active,
.slide-down-leave-active {
  transition: transform 0.2s ease;
}

.slide-down-enter-from,
.slide-down-leave-to {
  transform: translateY(-100%);
}

.slide-down-enter-to,
.slide-down-leave-from {
  transform: translateY(0);
}

/* app modal 共用樣式（PaymentSettingModal、ApplicationDetailModal） */
.app-identity {
  display: flex;
  align-items: center;
  gap: 12px;
}

.app-logo {
  width: 60px;
  height: 60px;
  flex-shrink: 0;
  border-radius: 2px;
  border: 1px solid var(--n-border-color);
  overflow: hidden;
}

.app-logo-img {
  width: 100%;
  height: 100%;
  object-fit: contain;
  display: block;
}

.app-logo-placeholder {
  width: 100%;
  height: 100%;
  background-color: #fff;
}

.app-name {
  font-size: 20px;
  font-weight: 700;
  line-height: 32px;
  color: var(--n-title-text-color);
  flex: 1;
}

.section-title {
  font-size: 14px;
  font-weight: 600;
  color: var(--n-title-text-color);
  padding-bottom: 8px;
  margin-bottom: 12px;
  border-bottom: 1px solid var(--n-border-color);
}

.form-items-wrapper {
  display: flex;
  flex-direction: column;
  gap: 20px;
}
</style>
